export const getDocConfig = (isDoc = true, share = false) => {
  return {
    autoTurnNewPage: true,
    enableThumb: false,
    hideBtn: getHideBtn(isDoc, share),
    hoverShow: [
      'CenterPageBtn'
    ],
    styles: {
      page: {
        marginTop: "-24px",
      }
    }
  }
}
export const getHideBtn = (isDoc = true, share = false) => {
  return {
    statusbar: true,
    toolbar: share ? {
      setPageTurning: true,
      setAnnotation: true,
      docList: !isDoc,
      thumbs: true
    } : true,
    zoom: true,
  }
}

export function getDocEvents(that) {
  return {
    'slide:next': () => {
      that.setMessage("nextSlide");
    },
    'slide:prev': () => {
      that.setMessage("prevSlide");
    },
    'scale:plus': () => {
      that.setMessage("setZoomPlus");
    },
    'scale:minus': () => {
      that.setMessage("setZoomMinus");
    },
    'setPage': (page) => {
      that.setMessage("slideTo", page);
    }
  }
}

export function encode(str) {
  var replace = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  // eslint-disable-next-line no-useless-escape
  return encodeURIComponent(str).replace(/[!'\(\)~]|%20|%00/g, function (match) {
    return replace[match];
  });
}

export function decode(str) {
  return str
    .replace(/[ +]/g, '%20')
    .replace(/(%[a-f0-9]{2})+/ig, function (match) {
      return decodeURIComponent(match);
    });
}

export function SearchParams(json) {
  if (typeof URLSearchParams !== "undefined") {
    return new URLSearchParams(json)
  }
  return Object.keys(json).map(name => name + '=' + encode(json[name])).join('&');
}